export const DepartmentsResource = {
  name: "Departments",
  path: "/inventory/departments",
  access: ["read-departments"],
};
